import { ReactNode } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ConfigProvider, theme as antdTheme } from 'antd'
import enUS from 'antd/locale/en_US'
import { ThemeProvider, useTheme } from '@/contexts/ThemeContext'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
})

function AntdTheme({ children }: { children: ReactNode }) {
  const { isDark } = useTheme()

  return (
    <ConfigProvider
      locale={enUS}
      theme={{
        algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: '#af0000',
          fontFamily: "'Poppins', ui-sans-serif, system-ui, sans-serif",
          borderRadius: 8,
          colorBgLayout: isDark ? '#000000' : '#f4f6f8',
          colorBgContainer: isDark ? '#0a0a0a' : '#ffffff',
          colorBorder: isDark ? '#222222' : '#e0e0e0',
          colorText: isDark ? '#f5f5f5' : '#1a1a2e',
          colorTextSecondary: isDark ? '#a1a1aa' : '#6c757d',
        },
        components: {
          Card: {
            borderRadiusLG: 12,
          },
          Table: {
            headerBg: isDark ? '#111111' : '#fafafa',
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AntdTheme>
          <BrowserRouter>{children}</BrowserRouter>
        </AntdTheme>
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
